import React, { useState } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { useIntl } from 'react-intl'
import { InfoCard } from '_components/InfoCard'

import ItemList, { AddNewItem, NoContent } from '../shared/items-list'
import { MainWrapper, Section } from '../styles'
import AddEditModal from './shared/add-edit-modal'
import RemoveButton from './shared/remove-button'

import styled from '@emotion/styled'

const fields = [
  { key: 'schoolName', name: 'School name', type: 'text', required: true },
  { key: 'degree', name: 'Degree', type: 'text', required: true },
  { key: 'domain', name: 'Field of study', type: 'text' },
  {
    key: 'yearStarted',
    name: 'Year started',
    type: 'date',
    minDate: moment().subtract(70, 'years'),
    maxDate: moment().add(10, 'years'),
    required: true,
  },
  {
    key: 'yearGraduated',
    name: 'Year graduated',
    type: 'date',
    minDate: moment().subtract(70, 'years'),
    maxDate: moment().add(10, 'years'),
    optional: {
      dateButton: 'iscurrenteducation',
      noDateButton: 'selectdate',
      noDateTitle: 'currenteducation',
    },
  },

  {
    key: 'websiteUrl',
    name: 'Website',
    type: 'url',
    placeholder: 'https://...',
  },
]

const TopWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${({ isOpen }) => isOpen && '35px'};
`

const ButtonsWrapper = styled.div`
  display: flex;
`

const ShowHideButton = styled.button`
  background: var(--shade);
  border: none;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  margin-left: 15px;
  i {
    font-size: 25px;
    color: var(--foreground);
  }
`

const Title = styled.h4`
  font-size: 22px;
  display: inline-block;
  font-weight: 400;
`

const mapStateToProps = ({ user }) => ({ user })

const Education = ({ user }) => {
  const [currentEducation, setCurrentEducation] = useState()
  const [addNewEducation, setAddNewEducation] = useState()
  const [deleteEducation, setDeleteEducation] = useState()
  const [isOpen, setIsOpen] = useState(true)
  const intl = useIntl()

  const { education } = user?.profile

  const onClose = () => {
    setAddNewEducation(false)
    setCurrentEducation(false)
    setDeleteEducation(false)
  }

  return (
    <MainWrapper>
      <Section>
        <TopWrapper isOpen={isOpen}>
          <Title>{intl.formatMessage({ id: 'user.profile.education' })}</Title>
          <ButtonsWrapper>
            {isOpen && (
              <AddNewItem
                onClick={() => setAddNewEducation(true)}
                testid="education"
              />
            )}
            <ShowHideButton onClick={() => setIsOpen(!isOpen)}>
              <i class={`fas fa-angle-${isOpen ? 'up' : 'down'}`} />
            </ShowHideButton>
          </ButtonsWrapper>
        </TopWrapper>
        {isOpen && (
          <ItemList>
            {education && education.length > 0 ? (
              education.map((edu) => {
                return (
                  <InfoCard
                    start={edu.yearStarted}
                    end={edu.yearGraduated}
                    url={edu.websiteUrl}
                    testid={edu.schoolName}
                    icon="fas fa-graduation-cap"
                  >
                    <div className="dropdown">
                      <p
                        onClick={() => setCurrentEducation(edu)}
                        data-testid={`btn-education-edit-${edu.schoolName}`}
                      >
                        edit
                      </p>
                      <p
                        onClick={() => setDeleteEducation(edu)}
                        data-testid={`btn-education-delete-${edu.schoolName}`}
                      >
                        delete
                      </p>
                    </div>

                    <div className="text">
                      <h4
                        data-testid={`education-schoolName-${edu.schoolName}`}
                      >
                        {edu.schoolName}
                      </h4>
                      {edu.domain && (
                        <p data-testid={`education-domain-${edu.schoolName}`}>
                          {edu.domain}
                        </p>
                      )}
                      <p data-testid={`education-degree-${edu.schoolName}`}>
                        {edu.degree}
                      </p>
                    </div>
                  </InfoCard>
                )
              })
            ) : (
              <NoContent>
                <i className="empty-icon fas fa-graduation-cap"></i>
                <span className="empty-label">
                  {intl.formatMessage({
                    id: 'user.profile.education.noeducation.message',
                  })}
                </span>
              </NoContent>
            )}
            {(currentEducation || addNewEducation) && (
              <AddEditModal
                onClose={onClose}
                currentItem={currentEducation}
                fields={fields}
                type="education"
              />
            )}
            {deleteEducation && (
              <RemoveButton
                onClose={onClose}
                deleteItem={deleteEducation}
                type="education"
              />
            )}
          </ItemList>
        )}
      </Section>
    </MainWrapper>
  )
}

export default connect(mapStateToProps)(Education)
